enum EmailType {
  Work = 'Work',
  Personal = 'Personal',
  Unspecified = 'Unspecified'
}

export default EmailType;

export const EmailTypeLabel: Record<EmailType, string> = {
  Work: 'Work',
  Personal: 'Personal',
  Unspecified: 'Other'
};

export const getEmailTypeAsList = (): CommonList[] => {
  return Object.values(EmailType).map((type: EmailType) => {
    return { label: EmailTypeLabel[type], id: type };
  });
};
